import type { ReactNode } from 'react';
import Menu, { MenuDivider, type MenuProps } from '@/components/Menu';
import { DeleteIcon, EditIcon } from '@/icons';
import MenuOption from './MenuOption';
import { classes } from './utils';

export { MenuOption, MenuDivider };

export type DefaultOptionsMenuProps = {
  open: boolean;
  separateDelete?: boolean;
  className?: string;
  anchorTo: HTMLElement | null;
  anchorOrigin?: MenuProps['anchorOrigin'];
  transformOrigin?: MenuProps['transformOrigin'];
  extraOptions?: ReactNode;
  onEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
};

export default function DefaultOptionsMenu({
  open,
  separateDelete,
  className = '',
  anchorTo,
  anchorOrigin,
  transformOrigin,
  extraOptions,
  onEdit,
  onDelete,
  onClose,
}: DefaultOptionsMenuProps) {
  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      className={className}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      {extraOptions}
      <MenuOption
        label="Edit"
        icon={<EditIcon fontSize="small" />}
        onClick={onEdit}
      />
      {separateDelete && <MenuDivider />}
      <MenuOption
        className={classes.deleteIcon}
        label="Delete"
        icon={<DeleteIcon fontSize="small" color="red-2" />}
        onClick={onDelete}
      />
    </Menu>
  );
}
